package meineglasfaser.frontend.admin.components.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.navigation.Anchor
import io.ktor.http.*
import kotlinx.coroutines.flow.MutableStateFlow
import meineglasfaser.api.AdminUserRole
import meineglasfaser.api.routes.PrefetchRoutes
import meineglasfaser.frontend.admin.components.AdminUserState
import meineglasfaser.frontend.admin.components.LocalAdminUserState
import meineglasfaser.frontend.common.components.widgets.PromLogo
import meineglasfaser.frontend.common.components.widgets.PromLogoType
import meineglasfaser.frontend.common.components.widgets.prefetch
import org.jetbrains.compose.web.dom.*

val NetworkCategoryVersion = MutableStateFlow(0)

@Composable
fun AdminSidebar() {
    val version by NetworkCategoryVersion.collectAsState()
    val baseInfo = LocalAdminUserState.current.baseInfoOrNull()

    Aside {
        Anchor(href = "/", attrs = { classes("logo") }) {
            PromLogo(PromLogoType.MAIN_COMPACT)
        }
        Nav {
            Ul {
                MenuEntry(
                    displayName = "Dashboard",
                    href = "/",
                )
                // TODO better user management
                if (baseInfo != null && baseInfo.roles.contains(AdminUserRole.ADMIN)) {
                    val networkCategories = prefetch(PrefetchRoutes.NetworkCategories(), version)
                    MenuEntry(
                        displayName = "Netzkategorien / Netze",
                        href = "/networks",
                    )
                    for (networkCategory in networkCategories) {
                        MenuEntry(
                            displayName = networkCategory.label,
                            href = "/networks/${networkCategory.id}",
                        )
                    }
                    MenuEntry(
                        displayName = "Shop",
                        href = "/shop",
                    )
                    MenuEntry(
                        displayName = "Bestellungen",
                        href = "/shop/bestellungen",
                    )
                    MenuEntry(
                        displayName = "Produkte",
                        href = "/shop/products",
                    )
                    MenuEntry(
                        displayName = "Addon-Gruppen",
                        href = "/shop/addon-groups",
                    )
                    MenuEntry(
                        displayName = "Kundenstamm",
                        href = "/kundenstamm",
                    )
                    MenuEntry(
                        displayName = "Erhebungen",
                        href = "/survey",
                    )
                    MenuEntry(
                        displayName = "Alle Einträge",
                        href = "/survey/entries",
                    )
//                MenuEntry(
//                    displayName = "Workflow",
//                    href = "/workflow",
//                )
                    MenuEntry(
                        displayName = "Störungen",
                        href = "/incidents",
                    )
                }
                MenuEntry(
                    displayName = "Lassnitzhöhe Tool",
                    href = "/external/laho",
                )
            }
        }
        FlowUserPill()
    }
}

@Composable
private fun MenuEntry(
    displayName: String,
    href: String,
) {
    val ctx = rememberPageContext()
    val segmentedCurrent = remember(ctx.route.path) {
        Url(ctx.route.path).segments
    }
    val segmentedTarget = remember(href) {
        Url(href).segments
    }
    val level = segmentedTarget.size.coerceAtLeast(1)
    Li(attrs = {
        classes("entry")
        attr("data-level", level.toString())
        if (segmentedTarget.size > 1 && segmentedCurrent.firstOrNull() != segmentedTarget.firstOrNull()) {
            classes("d-none")
        }
    }) {
        Anchor(
            href = href,
            attrs = {
                if (segmentedCurrent == segmentedTarget) {
                    classes("primary")
                } else {
                    classes("text-pill")
                }
            },
        ) {
            Text(displayName)
        }
    }
}

@Composable
private fun FlowUserPill() {
    val ctx = rememberPageContext()
    val flowUserState = LocalAdminUserState.current
    if (flowUserState is AdminUserState.LoggedIn) {
        val baseInfo = flowUserState.baseInfo
        Text(baseInfo.id)
        Button(attrs = {
            onClick {
                ctx.router.navigateTo("/auth/logout")
            }
        }) {
            Text("Logout")
        }
    }
}
